import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface TopBarProps {
  onMenuToggle: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ onMenuToggle }) => {
  const { user, logout, changeSelectedBusiness } = useAuth();
  const navigate = useNavigate();
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showBusinessDropdown, setShowBusinessDropdown] = useState(false);

  const toggleUserDropdown = () => {
    setShowUserDropdown(!showUserDropdown);
    // Close business dropdown when user dropdown is toggled
    setShowBusinessDropdown(false);
  };

  const toggleBusinessDropdown = () => {
    setShowBusinessDropdown(!showBusinessDropdown);
    // Close user dropdown when business dropdown is toggled
    setShowUserDropdown(false);
  };

  const handleLogout = () => {
    setShowUserDropdown(false);
    setShowBusinessDropdown(false);
    logout();
  };

  const handleNavigation = () => {
    // Close dropdowns when navigating
    setShowUserDropdown(false);
    setShowBusinessDropdown(false);
  };

  const handleBusinessSelect = (business: any) => {
    changeSelectedBusiness(business);
    setShowBusinessDropdown(false);
  };

  const handleDashboardNavigation = () => {
    setShowUserDropdown(false);
    setShowBusinessDropdown(false);
    navigate("/dashboard");
  };

  // Create display name and initials
  const displayName = user ? `${user.firstName} ${user.lastName}`.trim() : "";
  const initials = user
    ? `${user.firstName?.charAt(0) || ""}${
        user.lastName?.charAt(0) || ""
      }`.toUpperCase() || user.username?.charAt(0).toUpperCase()
    : "";

  return (
    <>
      {/* Overlays */}
      {showUserDropdown && (
        <div
          className="dropdown-overlay"
          onClick={() => setShowUserDropdown(false)}
        ></div>
      )}
      {showBusinessDropdown && (
        <div
          className="dropdown-overlay"
          onClick={() => setShowBusinessDropdown(false)}
        ></div>
      )}

      {/* Top Bar */}
      <div
        className="top-bar"
        onClick={() => {
          setShowUserDropdown(false);
          setShowBusinessDropdown(false);
        }}
      >
        <div className="top-bar-content">
          <button
            className="menu-toggle"
            onClick={(e) => {
              e.stopPropagation();
              onMenuToggle();
            }}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
          <div
            className="app-title"
            onClick={handleDashboardNavigation}
            style={{
              cursor: "pointer",
              transition: "opacity 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "0.7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
          >
            {/*<span className="brand-icon">💼</span>*/}
            <span className="brand-text">JSCP</span>
          </div>
          <div className="top-bar-user-info">
            {user?.SelectedBusiness &&
              user?.businesses &&
              user.businesses.length > 1 && (
                <div
                  className="business-selector"
                  style={{ position: "relative", marginRight: "1rem" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="business-name"
                    onClick={toggleBusinessDropdown}
                    style={{
                      fontSize: "0.875rem",
                      color: "#667eea",
                      fontWeight: "500",
                      padding: "0.5rem 0.5rem",
                      background: "rgba(103, 126, 234, 0.1)",
                      borderRadius: "4px",
                      border: "none",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.25rem",
                    }}
                  >
                    {user.SelectedBusiness.name}
                    <span style={{ fontSize: "0.7rem" }}>▼</span>
                  </button>
                  {showBusinessDropdown && (
                    <div
                      className="business-dropdown"
                      style={{
                        position: "absolute",
                        top: "35px",
                        left: "0",
                        background: "white",
                        borderRadius: "8px",
                        minWidth: "200px",
                        zIndex: 1000,
                        border: "1px solid #e0e0e0",
                        overflow: "hidden",
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
                      }}
                    >
                      {user.businesses.map((business: any) => (
                        <button
                          key={business.id}
                          className="business-dropdown-item"
                          onClick={() => handleBusinessSelect(business)}
                          style={{
                            display: "block",
                            width: "100%",
                            padding: "10px 16px",
                            color:
                              user.SelectedBusiness?.id === business.id
                                ? "#667eea"
                                : "#5f6368",
                            background:
                              user.SelectedBusiness?.id === business.id
                                ? "rgba(103, 126, 234, 0.1)"
                                : "transparent",
                            border: "none",
                            textAlign: "left",
                            cursor: "pointer",
                            fontSize: "0.875rem",
                            fontWeight:
                              user.SelectedBusiness?.id === business.id
                                ? "500"
                                : "normal",
                          }}
                          onMouseEnter={(e) => {
                            if (user.SelectedBusiness?.id !== business.id) {
                              e.currentTarget.style.background = "#f5f5f5";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (user.SelectedBusiness?.id !== business.id) {
                              e.currentTarget.style.background = "transparent";
                            }
                          }}
                        >
                          {business.name}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}
            {user?.SelectedBusiness &&
              (!user?.businesses || user.businesses.length <= 1) && (
                <span
                  className="business-name"
                  style={{
                    fontSize: "0.875rem",
                    color: "#667eea",
                    fontWeight: "500",
                    marginRight: "1rem",
                    padding: "0.25rem 0.5rem",
                    background: "rgba(103, 126, 234, 0.1)",
                    borderRadius: "4px",
                  }}
                >
                  {user.SelectedBusiness.name}
                </span>
              )}
            {/*<span className="user-name">{displayName || user?.username}</span>*/}
            <div
              className="user-avatar-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="user-avatar-topbar"
                onClick={toggleUserDropdown}
                title="User Menu"
              >
                {initials}
              </div>
              {showUserDropdown && (
                <div className="user-dropdown">
                  <div className="user-dropdown-header">
                    <div className="user-dropdown-avatar">{initials}</div>
                    <div className="user-dropdown-info">
                      <div className="user-dropdown-name">
                        {displayName || user?.username}
                      </div>
                      <div className="user-dropdown-email">{user?.email}</div>
                    </div>
                  </div>
                  <div className="user-dropdown-divider"></div>
                  <div className="user-dropdown-actions">
                    <Link
                      to="/settings"
                      className="user-dropdown-item"
                      onClick={handleNavigation}
                    >
                      <span className="user-dropdown-icon">👤</span>
                      Settings
                    </Link>
                    <button
                      style={{ color: "#d93025" }}
                      className="user-dropdown-item"
                      onClick={handleLogout}
                    >
                      <span className="user-dropdown-icon">⏻</span>
                      Sign out
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBar;
